import { render } from "./SFormElementTextInput.vue?vue&type=template&id=61172226"
import script from "./SFormElementTextInput.vue?vue&type=script&lang=js"
export * from "./SFormElementTextInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__